import { render } from "./App.vue?vue&type=template&id=bd84fee2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bd84fee2&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=bd84fee2&lang=css"

import exportComponent from "/root/logs/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd84fee2"]])

export default __exports__